import { Level } from '@enums/level.enum';
import { HttpHelper } from '@helpers/http.helper';

export interface MissionAcceptanceAcceptationJson {
  id: number;
  client_contacted: boolean;
  company_investigation: boolean;
  activity_risk: Level;
  legal_characteristics_risk: Level;
  fiscal_social_client_history_risk: Level;
  accounting_organization_risk: Level;
  mission_object: boolean;
  client_additional_needs: boolean;
  specific_deadlines: boolean;
  independent_from_client: boolean;
  legal_structure_competent_for_mission: boolean;
  company_consistent_with_partner_methods: boolean;
  contract_consistent_with_proposed_mission: boolean;
}

export class MissionAcceptanceAcceptation {
  constructor(
    public id?: number,
    public clientContacted?: boolean,
    public companyInvestigation?: boolean,
    public activityRisk?: Level,
    public legalCharacteristicsRisk?: Level,
    public fiscalSocialClientHistoryRisk?: Level,
    public accountingOrganizationRisk?: Level,
    public missionObject?: boolean,
    public clientAdditionalNeeds?: boolean,
    public specificDeadlines?: boolean,
    public independentFromClient?: boolean,
    public legalStructureCompetentForMission?: boolean,
    public companyConsistentWithPartnerMethods?: boolean,
    public contractConsistentWithProposedMission?: boolean
  ) {}

  static fromJson(json: Partial<MissionAcceptanceAcceptationJson>): MissionAcceptanceAcceptation {
    return new MissionAcceptanceAcceptation(
      json.id,
      json.client_contacted,
      json.company_investigation,
      json.activity_risk,
      json.legal_characteristics_risk,
      json.fiscal_social_client_history_risk,
      json.accounting_organization_risk,
      json.mission_object,
      json.client_additional_needs,
      json.specific_deadlines,
      json.independent_from_client,
      json.legal_structure_competent_for_mission,
      json.company_consistent_with_partner_methods,
      json.contract_consistent_with_proposed_mission
    );
  }

  static toJson(missionAcceptanceAcceptation: MissionAcceptanceAcceptation): MissionAcceptanceAcceptationJson {
    return {
      id: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.id),
      client_contacted: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.clientContacted),
      company_investigation: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.companyInvestigation),
      activity_risk: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.activityRisk),
      legal_characteristics_risk: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.legalCharacteristicsRisk),
      fiscal_social_client_history_risk: HttpHelper.toJsonProperty(
        missionAcceptanceAcceptation.fiscalSocialClientHistoryRisk
      ),
      accounting_organization_risk: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.accountingOrganizationRisk),
      mission_object: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.missionObject),
      client_additional_needs: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.clientAdditionalNeeds),
      specific_deadlines: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.specificDeadlines),
      independent_from_client: HttpHelper.toJsonProperty(missionAcceptanceAcceptation.independentFromClient),
      legal_structure_competent_for_mission: HttpHelper.toJsonProperty(
        missionAcceptanceAcceptation.legalStructureCompetentForMission
      ),
      company_consistent_with_partner_methods: HttpHelper.toJsonProperty(
        missionAcceptanceAcceptation.companyConsistentWithPartnerMethods
      ),
      contract_consistent_with_proposed_mission: HttpHelper.toJsonProperty(
        missionAcceptanceAcceptation.contractConsistentWithProposedMission
      )
    };
  }
}
